module.exports = __webpack_public_path__ + "static/media/bz.0e7f7596.svg";